import { CRM_API, RequestHelper } from "utils";

const RUTA = "entidad";
export const EntidadService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/listar`, params);
    });
  };

  return {
    listado,
  };
})();
